import useBlockedUsers from "../hooks/useBlockedUsers";

/** Loads the signed-in user's block list at app start so list filtering applies everywhere. */
export default function BlockListLoader() {
  useBlockedUsers();
  return null;
}
